import client from './client'
import install from './install'

// 子模块
import quote from './quote'

/**
 * xlgg market proxy
 * http://gitlab.yintech.net/ytx/paprika/NewBee/backend/xlgg-market-proxy/tree/master
 */
export default class MarketProxy {
  constructor (options) {
    if (MarketProxy.instance) {
      throw new Error('MarketProxy is singleton')
    }
    MarketProxy.instance = this
    this.options = options

    client.defaults.baseURL = options.baseURL

    this.quote = quote
  }
}

MarketProxy.instance = null
MarketProxy.install = install



// WEBPACK FOOTER //
// ./src/plugins/market-proxy/index.js